import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from 'styled-components';
import { ContainerContentStyled, ContainerStyled } from './styles';
import useContainerProps, { directionStyling } from './use-container-props';
const Container = (props) => {
    var _a, _b, _c, _d;
    const { removeContainer } = props;
    const { currentProps, currentContentProps, generalProps } = useContainerProps(props);
    const theme = useTheme();
    const { className, id, children } = generalProps;
    const classes = classNames('Container', {
        [`${className}`]: className,
    });
    if (removeContainer) {
        return (_jsx(ContainerStyled, Object.assign({}, currentProps, { id: id, children: _jsx(ContainerContentStyled, { "$default": Object.assign({ width: '100%' }, directionStyling(theme, (_a = props.direction) !== null && _a !== void 0 ? _a : 'column', (_b = props.alignement) !== null && _b !== void 0 ? _b : 'center')), "$ultra": {}, "$wide": {}, "$xxl": {}, "$xl": {}, "$lg": {}, "$md": {}, "$tablet": {}, "$mobile": {}, className: classes, style: Object.assign({}, ((_d = (_c = props === null || props === void 0 ? void 0 : props.styles) === null || _c === void 0 ? void 0 : _c.content) !== null && _d !== void 0 ? _d : {})), children: children }) })));
    }
    return (_jsx(ContainerStyled, Object.assign({}, currentProps, { id: id, children: _jsx(ContainerContentStyled, Object.assign({}, currentContentProps, { className: classes, children: children })) })));
};
export default Container;
